// EmployeeTerminationApproval.js

import React, { useEffect, useState } from 'react';
import './EmployeeTerminationApprovalHr.css';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import {
    getPendingTerminationsHR,
    approveTerminationHR
} from '../../../services/resignationService';
import { format } from 'date-fns';
import { capitalizeFirstLetter } from '../../../utils/validations';

const EmployeeTerminationApprovalHr = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [action, setAction] = useState({});
    const [hrRemarks, setHrRemarks] = useState('');
    const [errors, setErrors] = useState({});
    const [rowLoading, setRowLoading] = useState({});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await getPendingTerminationsHR();
            setData(res);

         

        } catch (e) {
            setErrors({ fetch: 'Failed to load data' });
        } finally {
            setLoading(false);
        }
    };

    const handleAction = (id, value) => {
        setAction(prev => ({ ...prev, [id]: value }));
        setErrors(prev => ({ ...prev, [id]: null }));
    };

    // const handleRemarks = (id, value) => {
    //     setHrRemarks(prev => ({ ...prev, [id]: value }));
    // };

    const validate = (id) => {
        if (!action[id]) {
            setErrors(prev => ({ ...prev, [id]: 'Select approve/reject' }));
            return false;
        }
        if (action[id] === 'reject') {
            setErrors(prev => ({ ...prev, [id]: 'Remarks required for reject' }));
            return false;
        }
        return true;
    };

    const handleSubmit = async (id) => {
        if (!validate(id)) return;

        const audit = getAuditLog();

        const payload = {
            approved: action[id] === 'approve',
            hrRemarks: hrRemarks.trim() || "",
            managerId: audit?.employeeId || '',
            auditlog: {
                name: audit?.name || '',
                role: audit?.role || '',
                employeeId: audit?.employeeId || ''
            }
        };

        setRowLoading(prev => ({ ...prev, [id]: true }));

        try {
            await approveTerminationHR(id, payload);
            setData(prev => prev.filter(d => d.id !== id));
        } catch (e) {
            setErrors(prev => ({
                ...prev,
                [id]: 'Failed to submit'
            }));
        } finally {
            setRowLoading(prev => ({ ...prev, [id]: false }));
        }
    };

    if (loading) return <div className="hr-loader">Loading...</div>;

    return (
        <div className="hr-container">
            <h2 className="hr-title">HR Termination Approval</h2>

            {errors.fetch && <div className="hr-error-banner">{errors.fetch}</div>}

            <div className="hr-table-wrapper">
                <table className="hr-table">
                    <thead>
                        <tr className="hr-header">
                            <th>S.No</th>
                            <th>District</th>
                            <th>Employee Name</th>
                            <th>Contact</th>
                            <th>Email</th>
                            <th>Designation</th>
                             <th>Requested By</th>
                             <th>Joining Date</th>
                            <th>Termination Date</th>
                            <th>APM Reason </th>
                            <th>Approved Date</th>
                            <th>Approved By</th>
                            <th>PM Reason </th>
                            <th>HR Remarks</th>
                            <th>Action</th>
                            <th>Submit</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="15" className="hr-empty">
                                    No pending requests
                                </td>
                            </tr>
                        ) : (
                            data.map((t, i) => (
                                <tr key={t.id}>
                                    <td>{i + 1}</td>
                                    <td>{t.district}</td>
                                    <td>{t.employeeName}</td>
                                    <td>{t.contact}</td>
                                    <td>{t.email}</td>
                                    <td>{t.designation}</td>
                                    {/* <td>{format(t.requestDate, 'dd-MM-yyyy')}</td> */}
                                    <td>{capitalizeFirstLetter(t.requestedBy)}</td>
                                    <td className=' text-nowrap'>{format(t.joiningDate, 'dd-MM-yyyy')}</td>
                                    <td>{format(t.requestedTerminationDate, 'dd-MM-yyyy')}</td>

                                    {/* Reason 1 */}
                                    <td className="hr-reason">{t.reason}</td>

                                    {/* Approved Date */}
                                    <td className=' text-nowrap'>{format(t.approvedDate, 'dd-MM-yyyy') || '-'}</td>

                                    {/* Approved By */}
                                    <td>{t.approvedByName || '-'}</td>

                                    {/* Reason 2 (Manager Remarks) */}
                                    <td className="hr-reason">
                                        {t.pmRemarks || '-'}
                                    </td>

                                    {/* HR Remarks */}
                                    <td>
                                    
                                        <input
                                            className="hr-textarea"
                                            placeholder="Enter HR remarks"
                                            value={hrRemarks}
                                            title={hrRemarks}
                                            onChange={(e) => setHrRemarks(e.target.value)}
                                        />
                                    </td>

                                    {/* Action */}
                                    <td className="">
                                        <div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={action[t.id] === 'approve'}
                                                    onChange={() =>
                                                        handleAction(t.id, 'approve')
                                                    }
                                                />
                                                Approve
                                            </label>

                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={action[t.id] === 'reject'}
                                                    onChange={() =>
                                                        handleAction(t.id, 'reject')
                                                    }
                                                />
                                                Reject
                                            </label>
                                        </div>
                                    </td>

                                    {/* Submit */}
                                    <td>
                                        <button
                                            className="hr-btn"
                                            onClick={() => handleSubmit(t.id)}
                                            disabled={rowLoading[t.id]}
                                        >
                                            {rowLoading[t.id] ? 'Saving...' : 'Submit'}
                                        </button>

                                        {errors[t.id] && (
                                            <div className="hr-error">
                                                {errors[t.id]}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmployeeTerminationApprovalHr;